import { computed } from '@ember/object';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import MoneyNegatorProxy from '@square/dashboard-money/utils/money-negator-proxy';
import Itemization from '@square/dashboard-data/models/squareup/beemo/api/v2/models/itemization';
export default ProtoBaseModel.extend({
  itemization: attr(Itemization),
  negatedItemization: computed('itemization', function () {
    return MoneyNegatorProxy.create({
      toNegate: this.itemization
    });
  })
});